<script>
import ListingModel from "@/views/Evaluation/File/Components/ListingModel.vue"

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel
        type="EVALUATION_TRAINING_HOT"
        root-path="evaluation_training_hot_files"
    />
</template>